import i18n from '@/locales'
export const CategoryMap = {
  tag: i18n.t('cloudenv.text_16'),
  cloudregion: i18n.t('cloudenv.text_9'),
}

export const ConditionMap = {
  in: i18n.t('cloudenv.text_390'),
  contains: i18n.t('cloudenv.text_390'),
  not_in: i18n.t('cloudenv.text_391'),
  except: i18n.t('cloudenv.text_392'),
}
